<template>
  <div class="c-progress">
    <div class="c-progress-outer" :style="setProgressBgStyle" ref="progress">
      <div class="c-progress-inner" :style="setProgressStyle"></div>
      <div class="c-progress-get" :style="setProgressgetStyle"></div>
      <div v-if="showSlider" class="c-progress-slider" :class="{sliderS:sliderS}" ref="slider" :style="setSliderStyle"></div>
    </div>
    <span v-if="showPerText">{{tempPercent}}%</span>
  </div>
</template>

<script>
    // 使用了element的颜色
    const colorTable = {
        success: '#13ce66',
        fail: '#ff4949',
        warning: '#e6a23c',
        default: '#409EFF'
    }
    export default {
        name: 'CProgress',
        props: {
            percent: {
                type: Number,
                default: 0
            },
            getPercent: {
                type: Number,
                default: 0
            },
            showSlider: {
                type: Boolean,
                default: true
            },
            showPerText: {
                type: Boolean,
                default: true
            },
            // 进度条的宽度
            width: {
                type: Number,
                default: 300
            },
            bgColor: {
                type: String,
                default: '#ebeef5'
            },
            progressColor: {
                type: String,
                default: '#409EFF'
            },
            // 滑块的宽度
            sliderWidth: {
                type: Number,
                default: 20
            },
            // 颜色的类型
            type: {
                type: String,
                default: colorTable.default
            }
        },
        data () {
            return {
                sliderLeft: 0, // 滑块相对父元素发x坐标
                progressWidth: 0, // 进度条当前的的宽度
                tempPercent: 0,
                sliderS: true,
                getprogressWidth: 0,
            }
        },
        watch:{
            percent(newVal){
                // console.log(newVal)
                this.sliderLeft = this.width / 100 * newVal
                this.progressWidth = Math.ceil(this.sliderLeft + this.sliderWidth) // 滑块的x坐标加上滑块的宽度
                console.log(this.progressWidth)
                this.tempPercent = newVal
            },
            getPercent(newVal){
                // console.log(newVal)
                let left = this.width / 100 * newVal
                this.getprogressWidth = left
            },

        },
        computed: {
            // 设置进度条的背景样式
            setProgressBgStyle () {
                return {
                    // 加上滑块的宽度
                    width: `${this.width + this.sliderWidth}px`
                }
            },
            // 设置进度条的样式
            setProgressStyle () {
                const color = colorTable[this.type] || this.progressColor
                return {
                    width: `${this.progressWidth}px`,
                    background: color
                }
            },
            setProgressgetStyle(){
                return {
                    width: `${this.getprogressWidth}px`,
                    background: '#808080'
                }
            },
            // 设置滑块的样式
            setSliderStyle () {
                const color = colorTable[this.type] || this.progressColor
                return {
                    border: `1px solid ${color}`,
                    width: `${this.sliderWidth}px`,
                    height: `${this.sliderWidth}px`,
                    left: `${this.sliderLeft}px`
                }
            }
        },
        mounted () {
            this.sliderLeft = this.width / 100 * this.percent
            this.progressWidth = this.sliderLeft + this.sliderWidth // 滑块的x坐标加上滑块的宽度
            this.tempPercent = this.percent
            this.addListener()
        },
        methods: {
            addListener () {
                const slider = this.$refs.slider
                const progress = this.$refs.progress
                let isClickSlider = false
                let distance = 0 // 滑块与点击坐标的绝对距离
                progress.onclick = (e) => {
                    // console.log(e)
                    
                    // 阻止事件冒泡
                    if (e.target == slider) {
                        return
                    }
                    let curX = progress.offsetLeft
                    this.sliderLeft = e.pageX - 15 - curX
                    if (this.sliderLeft <= 0) {
                        this.sliderLeft = 0
                    }
                    if (this.sliderLeft >= this.width) {
                        this.sliderLeft = this.width
                    }
                    // console.log('progress.offsetLeft',progress.offsetLeft)
                    // console.log('e.pageX - 15',e.pageX - 15)
                    // console.log('curX',curX)
                    this._countCurPercent()
                }
                slider.onmousedown = (e) => {
                    console.log(e)
                    isClickSlider = true
                    let curX = slider.offsetLeft
                    distance = e.pageX - 15 - curX // 得出绝对距离
                    this._countCurPercent()
                }
                progress.onmousemove = (e) => {
                    if (isClickSlider) {
                        // 判断是否已经超出进度条的长度
                        if ((e.pageX - 15 - distance) >= 0 && (e.pageX - 15 - distance) <= (this.width - 0)) {
                            this.sliderLeft = e.pageX - 15 - distance
                            this._countCurPercent()
                        }
                    }
                    this.sliderS = false
                }
                progress.onmouseout = () => {
                    this.sliderS = true
                }
                progress.onmouseup = () => {
                    let that = this
                    this._countCurPercent()
                    setTimeout(function(){
                        that.$emit("upChange",'upDate')
                    },0)
                    
                    isClickSlider = false
                }
            },
            // 算出百分比
            _countCurPercent () {
                this.tempPercent = Math.ceil(parseInt(this.sliderLeft / this.width * 100))
                this.progressWidth = this.sliderLeft + 20
                // 取整的时候宽度可能不为0，所以在0和100的时候也将宽度取整
                if (this.tempPercent <= 0) {
                    this.progressWidth = 0
                    this.sliderLeft = 0
                }
                if (this.tempPercent >= 100) {
                    this.progressWidth = this.width + 20
                    this.sliderLeft = this.width
                }
                this.$emit('percentChange', this.tempPercent)
            }
        }
    }
</script>

<style scoped lang="scss">
  .c-progress {
    $width: 300px;
    $radius: 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
    span {
      margin-left: 5px;
      font-size: 14px;
      color: #666;
    }
    
    .c-progress-outer {
      width: $width;
      height: 10px;
      border-radius: $radius;
      background: #ebeef5;
      position: relative;
      display: flex;
      align-items: center;
      
      .c-progress-inner {
        width: 100px;
        height: 10px;
        background: #409EFF;
        border-radius: $radius;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
      }
      .c-progress-get{
        width: 100px;
        height: 10px;
        background: #808080;
        border-radius: $radius;
        position: absolute;
        top: 0;
        left: 0;
      }
      
      .c-progress-slider {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #409EFF;
        border: 1px solid #409EFF;
        position: absolute;
        z-index: 10;
        left: 10px;
        // display: none;
        cursor: pointer;
      }
      .sliderS{
          opacity: 0;
      }
    }
  }
</style>

